// useGoogleAuth.ts
import { useEffect, useState } from 'react';

const CLIENT_ID = '301722987834-pec5a9vlojn6redpcneblrgd2ckqdj05.apps.googleusercontent.com';
const API_KEY = 'AIzaSyCLbT_ImiBa4NBDDWrp1pgkFBbTxfBluRM';
const SCOPES = 'https://www.googleapis.com/auth/drive.file';

export const useGoogleAuth = () => {
  const [tokenClient, setTokenClient] = useState<google.accounts.oauth2.TokenClient | null>(null);
  const [gapiReady, setGapiReady] = useState(false);

  useEffect(() => {
    const loadScript = (src: string): Promise<void> => {
      return new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[src="${src}"]`);
        if (existing) return resolve();
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`No se pudo cargar el script: ${src}`));
        document.body.appendChild(script);
      });
    };

    const initializeGoogle = async () => {
      await loadScript('https://accounts.google.com/gsi/client');
      await loadScript('https://apis.google.com/js/api.js');

      const gapi = (window as any).gapi;
      const googleAccounts = (window as any).google;

      gapi.load('client', async () => {
        await gapi.client.init({
          apiKey: API_KEY,
          discoveryDocs: ['https://sheets.googleapis.com/$discovery/rest?version=v4']
        });

        const client: google.accounts.oauth2.TokenClient = googleAccounts.accounts.oauth2.initTokenClient({
          client_id: CLIENT_ID,
          scope: SCOPES,
          callback: (tokenResponse:any) => {
            if (tokenResponse.access_token) {
              gapi.client.setToken({ access_token: tokenResponse.access_token });
              setGapiReady(true);
            }
          }
        });

        setTokenClient(client);
      });
    };

    initializeGoogle();
  }, []);

  const requestAccessToken = () => {
    if (tokenClient) {
      tokenClient.requestAccessToken({ prompt: 'consent' });
    } else {
      console.warn("🚫 tokenClient no está listo aún.");
    }
  };

  return {
    gapi: (window as any).gapi,
    gapiReady,
    requestAccessToken,
    tokenClient
  };
};
